/* eslint-disable */

import cookiesHandler from '@/composables/cookiesHandler';
import router from '@/router';
import { useContextStore } from '@/stores/context';
import axios from 'axios';
import Response from './models/Response';
import AuthenticatorHandler from '@/composables/handlers/AuthenticatorHandler';
import StorageHandler from '@/composables/handlers/StorageHandler';

export default class ApiClient {
    requestResource;
    methods = {
        GET: 1,
        POST: 2,
        PUT: 3,
        DELETE: 4
    }

    /**
     * Inicializates ApiClient
     * @param {String} relativeUrl
     * @param {Boolean} authRequest
     * @param {Boolean} requestErrorHandler
     */
    constructor(relativeUrl = '/', authRequest = true, requestErrorHandler = true) {
        this.baseUrl = `${process.env.VUE_APP_API_URL}${relativeUrl}`;
        this.confAxios(authRequest, requestErrorHandler);
    }

    /**
     * Configurates this axios instance, setting it to 'requestResourse' attr
     * @param {Boolean} authRequest 
     * @param {Boolean} requestErrorHandler 
     */
    confAxios(authRequest, requestErrorHandler) {
        this.requestResource = axios.create({
            baseURL: this.baseUrl,
            headers: {
                'Accept': 'application/json',
                "Content-Type": "application/json"
            }
        });
        if (authRequest) {
            this.setRequestAuthorizationInterceptor();
        }
        if (requestErrorHandler)
            this.setRequestErrorHandlerInterceptor();
    }

    /**
     * 
     */
    setRequestAuthorizationInterceptor() {
        this.requestResource.interceptors.request.use(
            config => {
                const token = cookiesHandler.getEncryptedCookie('TM_TOKEN');
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );
    }

    setRequestErrorHandlerInterceptor() {
        this.requestResource.interceptors.response.use(
            response => response,
            error => {
                if (error.response == undefined) {
                    return {
                        data: {},
                        resMessage: 'a problem occurred with your application, reload the page or contact the suport',
                        status: 900
                    };
                } else {
                    throw error;
                }
            }
        );
    }

    /**
     * Perform an AXIOS request
     * @param {String} url 
     * @param {Object} parameters 
     * @param {Integer} method - this.methods
     * @param {Object} header
     * @returns {Response}
     */
    async executeRequest(url, parameters = {}, method = this.methods.GET, options = {}, ignoreAuthHandler = false) {
        if (!ignoreAuthHandler) {
            await AuthenticatorHandler.check();
        }

        let requestOptions = {
            params: method === 'get' ? parameters : undefined,
            responseType: options.responseType || 'json',
            headers: options.headers || {}
        };
        
        requestOptions.headers['Authorization'] = 'Bearer ' + StorageHandler.getEncryptedValue('tm_cervo_digital') ?? '';

        try {
            const response = await this._makeRequest(url, parameters, method, requestOptions);

            if (response.apiError()) {
                this._handleMaintenance();
                return response;
            }
            if (response.notAuthenticated()) {
                // this._handleMaintenance();
                return response;
            }

            return response;

        } catch (error) {
            return this._handleError(error, new Response({ code: 500, message: 'A problem occurred with your application, try again or contact the suport' }));
        }
    }

    /**
     * Builds the request accordingly to method
     * @param {String} url 
     * @param {Object} parameters 
     * @param {String} method 
     * @param {Object} options 
     * @returns 
     */
    async _makeRequest(url, parameters = {}, method, options) {
        parameters.user_lang = useContextStore.getLang ?? 'pt';

        let requestResults = {};
        switch (method) {
            case this.methods.GET:
                requestResults = await this.requestResource.get(this._buildGetUrl(url, parameters), options);
                break;
            case this.methods.POST:
                requestResults = await this.requestResource.post(url, parameters, options);
                break;
            case this.methods.PUT:
                requestResults = await this.requestResource.put(url, parameters, options);
                break;
            case this.methods.DELETE:
                requestResults = await this.requestResource.delete(url, parameters, options);
                break;
            default:
                throw new Error(`Método ${method} não suportado.`);
        }

        return new Response(requestResults, true);
    }

    /**
     * Builds GET urls
     * @param {String} baseUrl 
     * @param {Object} params 
     * @returns String
     */
    _buildGetUrl(baseUrl, params) {
        const query = new URLSearchParams();
        for (const key in params) {
            const value = params[key];
            if (Array.isArray(value)) {
                value.forEach((v, index) => query.append(`${key}[${index}]`, v));
            } else {
                query.append(key, value);
            }
        }
        return `${baseUrl}?${query.toString()}`;
    }

    /**
     * Saves session message and redirect to maintance page
     */
    _handleMaintenance() {
        // set erro message
        // this.redirect('/maintance');
    }

    /**
     * Handle request errors
     * @param {*} error 
     * @param {*} resultFormat 
     * @returns 
     */
    _handleError(error, resultFormat) {
        const defaultErrorMessage = 'Unexpected error, please try again later';

        resultFormat.success = false;
        resultFormat.data = '';
        resultFormat.status = 500;

        if (error?.response) {
            resultFormat.data = error.response.data;
            resultFormat.status = error.response.status;
            resultFormat.message = error.response.data?.message || defaultErrorMessage;
        } else {
            resultFormat.message = defaultErrorMessage;
        }

        return new Response({status: resultFormat.status, message: resultFormat.message, data: resultFormat.data});
    }

    redirect(url = '') {
        router.push({ path: url });
    }
}